var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c("div", { staticClass: "columns" }, [
        _c(
          "div",
          { staticClass: "column is-6" },
          [
            _c(
              "sc-field",
              {
                attrs: {
                  label: "Gostaria de esconder os valores duplicados",
                  prop: "duplicates"
                }
              },
              [
                _c(
                  "sc-switch",
                  {
                    model: {
                      value: _vm.quotingReturns.duplicates,
                      callback: function($$v) {
                        _vm.$set(_vm.quotingReturns, "duplicates", $$v)
                      },
                      expression: "quotingReturns.duplicates"
                    }
                  },
                  [_vm._v("\n            Sim\n          ")]
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "block" },
        [
          _c("sc-field", { attrs: { label: "Escolha o tipo de API" } }, [
            _c(
              "div",
              _vm._l(_vm.returnAPITypes, function(types) {
                return _c(
                  "sc-radio",
                  {
                    key: types.id,
                    attrs: { "native-value": types.id },
                    model: {
                      value: _vm.returnAPIType,
                      callback: function($$v) {
                        _vm.returnAPIType = $$v
                      },
                      expression: "returnAPIType"
                    }
                  },
                  [
                    _vm._v(
                      "\n          " + _vm._s(types.description) + "\n        "
                    )
                  ]
                )
              })
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("sc-quoting-return-tbl", {
        attrs: {
          "quoting-data": _vm.config_list,
          "mode-type": _vm.returnAPIType,
          "default-config-item": _vm.defaultConfigItem
        },
        on: { getconfiglistevt: _vm.getConfigList },
        scopedSlots: _vm._u([
          {
            key: "table-fields",
            fn: function(ref) {
              var props = ref.props
              return [
                _c(
                  "sc-table-column",
                  {
                    attrs: {
                      field: "delivery_method.id",
                      label: "Método de Entrega"
                    }
                  },
                  [
                    _c(
                      "sc-field",
                      [
                        _c("sc-quoting-dm-all", {
                          attrs: {
                            "call-get-dm-all": false,
                            "default-value": props.row.delivery_method
                              ? props.row.delivery_method.id
                              : 1
                          },
                          model: {
                            value: props.row.delivery_method.id,
                            callback: function($$v) {
                              _vm.$set(props.row.delivery_method, "id", $$v)
                            },
                            expression: "props.row.delivery_method.id"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45d5d314", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45d5d314","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-quote/features/quoting-return/components/sc-quoting-return-fixed/ScQuotingReturnFixed.vue
// module id = null
// module chunks = 